import { makeAutoObservable } from 'mobx';
import createRegionPreviewPoster from './fn/createRegionPreviewPoster';
import changeSelectedRegion from './fn/changeSelectedRegion';
import handlePreviewBallot from './fn/handlePreviewBallot';

export default class RegionPreviewStore {
    isChangingRegion: boolean = false;
    isDownloadingRegionPreview: boolean = false;
    sid: string = '';
    ballotPreviewRedirectUrl: string = '';

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isDownloadingRegionPreview = false;
        this.sid = '';
        this.ballotPreviewRedirectUrl = '';
    }

    setIsChangingRegion = (isChanging: typeof this.isChangingRegion) => {
        this.isChangingRegion = isChanging;
    };

    setIsDownloadingRegionPreview = (isLoading: typeof this.isDownloadingRegionPreview) => {
        this.isDownloadingRegionPreview = isLoading;
    };

    setSid = (sid: string) => {
        this.sid = sid;
    };

    setBallotPreviewRedirectUrl = (url: string) => {
        this.ballotPreviewRedirectUrl = url;
    };

    changeSelectedRegion = changeSelectedRegion;
    createRegionPreviewPoster = createRegionPreviewPoster;
    handlePreviewBallot = handlePreviewBallot;
}
